import vehicleListFilterConfig from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterConfig';
import type { FilterConfig } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore.types';
import type { OptionalFilters, VehicleListFilterQuery, VehicleListFilterQueryKeys } from 'Types/filter';
import { castToType } from 'Utilities/utils';

interface CastQueryParams {
	config?: FilterConfig;
	query: VehicleListFilterQueryWithUpdatedModel;
}

type VehicleListFilterQueryWithUpdatedModel = Partial<VehicleListFilterQuery> | { model: number[] };

export const castQueryParams = ({ config = vehicleListFilterConfig, query }: CastQueryParams): OptionalFilters => {
	const queryKeys = Object.keys(query) as VehicleListFilterQueryKeys[];
	return queryKeys.reduce((acc, key) => {
		const configEntry = config[key];
		if (configEntry) {
			// @ts-expect-error ignoring as type does not exist in various fields in vehicleListFilterConfig
			acc[key] = castToType({ type: configEntry?.type, value: query[key] });
		}
		return acc;
	}, {} as OptionalFilters);
};

const formatQueryToFilters = (query: VehicleListFilterQueryWithUpdatedModel): OptionalFilters =>
	castQueryParams({ query });

export default formatQueryToFilters;
